
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  API_TCaseOnlineApplication,
  API_TCaseOnlineApplicationCategories,
  API_TCaseOnlineApplicationSubs,
} from "@/models/case_online_application";

@Component({
  components: {
    CaseOnlineApplicationRow: () => import("./OnlineApplicationRow.vue"),
  },
})
export default class CaseOnlineApplication extends Vue {
  @Prop({ type: [Object, String], default: () => ({}) }) readonly src?: API_TCaseOnlineApplication;

  get categories(): API_TCaseOnlineApplicationCategories[] {
    return this.src?.online_application_categories ?? [];
  }

  getSubLabel(sub: API_TCaseOnlineApplicationCategories) {
    return sub.name;
  }

  getSubCategoryRows(sub: API_TCaseOnlineApplicationSubs) {
    return sub.online_application_rows ?? [];
  }

  getSubLooped(sub: API_TCaseOnlineApplicationSubs) {
    return sub.is_looped ?? false;
  }
}
